import Image from '@/components/image';
import NextLink from '@/components/next-link';

const FeatureCard = ({ info, isMobile, locale }) => {
  return (
    <NextLink
      href={info?.url ? `/${info?.url}` : '#'}
      className='rounded-lg border border-[#dddddd] px-5 py-3.5 md:px-20 md:py-7'
    >
      <div className='flex h-full flex-col items-center justify-center'>
        <Image
          className='mb-3 h-12 w-12'
          alt={info.url}
          src={
            isMobile ? info?.[`mobile-img-${locale}`] : info?.[`img-${locale}`]
          }
        />
        <p className='text-center text-lg font-semibold max-sm:text-sm'>
          {info?.[`title-${locale}`] || ''}
        </p>
        <p className='w-1/2 text-center text-sm text-gray-500 max-sm:text-[11px]'>
          {info?.[`description-${locale}`] || ''}
        </p>
      </div>
    </NextLink>
  );
};

export default FeatureCard;
